import { all } from 'redux-saga/effects';
import ProviderSaga from './Provider/ProviderSagas';
import ProviderLoginSaga from './Provider/ProviderLoginSagas';
import PatientSaga from './Patients/sagas';
import OrdersSaga from './Order/sagas';
import AlertSaga from './Alerts/sagas';

export default function* rootSaga() {
  yield all([ProviderLoginSaga(), ProviderSaga(), PatientSaga(), OrdersSaga(), AlertSaga()]);
}